/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Read_Along_Ai_ModelInputs */

const en_read_along_ai_model = /** @type {(inputs: Read_Along_Ai_ModelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Model`)
};

const es_read_along_ai_model = /** @type {(inputs: Read_Along_Ai_ModelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modelo`)
};

/**
* | output |
* | --- |
* | "Model" |
*
* @param {Read_Along_Ai_ModelInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_ai_model = /** @type {((inputs?: Read_Along_Ai_ModelInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_Ai_ModelInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_ai_model(inputs)
	return en_read_along_ai_model(inputs)
});